import { OwcTypography } from "@one/react";
import BookingTabContainer from "./BookingTabContainer";
import { useContext, useEffect } from "react";
import { BookingContext } from "../booking/context";
import CustomFilterWrapper from "../booking-instruments/booking-instruments-custom-filter/CustomFilterWrapper";
import { useSelector } from "react-redux";
import { BOOKING_POP_UP_WRAPPER_INITALIZE } from "../../constants";
import BookingPopUpWrapper from "../booking/BookingPopUpWrapper";
import { uniq } from "lodash";
import styles from "./BookEquipmentMainPage.module.scss";

const BookEquipmentMainPage = ({ setSubscriptionStatus, setPopupEnableStatus, landingPageAppSyncClient }) => {
  const { isEditMode, isDuplicate, editBookingData, dispatchAction } = useContext(BookingContext);

  const store = useSelector((store) => store.user);

  // If we arrived via create-from-equipment flow, we temporarily set isEditMode to true
  // to pass preSelected equipment list. After mount, revert isEditMode back to false
  // so the UI shows Confirm instead of Save. Keep isCreateMode=true to preserve
  // draft prefill values in Step 3 initialization.
  useEffect(() => {
    if (isEditMode && editBookingData && !editBookingData.id) {
      dispatchAction({
        type: "editBookingData",
        payload: {
          isEditMode: false,
          isCreateMode: true
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CustomFilterWrapper
      initialValues={{ site: store?.site }}
      preSelectedList={(isEditMode || isDuplicate) ? uniq(editBookingData?.bookingEntries.map((x) => x.inventoryId)) : []}
    >
      <BookingPopUpWrapper initialValues={BOOKING_POP_UP_WRAPPER_INITALIZE}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            width: "100%",
            paddingTop: 8,
            paddingBottom: 8,
          }}
        >
          <div
            className={styles.pageTitle}
          >
            <OwcTypography variant="title5"
            style={{'fontSize':16, padding:16, fontStyle: 'normal',fontWeight: 500}}>{(isEditMode && !isDuplicate) ? "Edit event" : "Book equipment"}</OwcTypography>
          </div>
          <BookingTabContainer
            setSubscriptionStatus={setSubscriptionStatus}
            setPopupEnableStatus={setPopupEnableStatus}
            landingPageAppSyncClient={landingPageAppSyncClient}
          />
        </div>
      </BookingPopUpWrapper>
    </CustomFilterWrapper>
  );
};

export default BookEquipmentMainPage;
